// @ts-nocheck
// Greif UI Kit = line-ships-from
import * as React from "react";

const Factory: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M4.308 21.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278v-8.18q0-.543.292-1 .29-.456.808-.677l3.634-1.533a.92.92 0 0 1 .86.065q.406.246.406.748v.625l3.76-1.507a.85.85 0 0 1 .846.09.86.86 0 0 1 .394.748V10.5h8v9.192q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h15.384a.3.3 0 0 0 .221-.087.3.3 0 0 0 .087-.22V12h-8V9.95l-5 2V10l-2.817 1.248a.3.3 0 0 0-.135.11.3.3 0 0 0-.048.169v8.165a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087m6.808-2.23h1.768v-3.54h-1.768zm-4 0h1.768v-3.54H7.115zm8 0h1.768v-3.54h-1.768zM21.5 10.5h-4.058l.92-6.933a.77.77 0 0 1 .773-.682h.769q.279 0 .482.187t.243.466zM4.308 20H4h16z"
            />
        </svg>
    );
};

export default React.memo(Factory);
